/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Select from 'react-select';
import config from '../../config/config';
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../constants";
import moment from 'moment';
import "./P2PMainComp.css";
import styles from "./P2PMainComp.module.css";
import { FiChevronsDown, FiChevronsUp } from "react-icons/fi";
import ReusableTableMini from './miniTableComp';
import ReusableChartTableMini from './chartAndMiniTable';
import GLAgingDoughnutChartTable from './GLAgingDoughnutChart';
import GLReusableTable from './GLReusableTable/GLReusableTable';

const { API_BASE_URL } = config;


const GLRconcilationDashboard = () => {

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);
  const history = useHistory();

  const location = useLocation();
  const initialFilters = location.state || {
    entityData: null,
    glAccData: null,
    glTypeData: null,
    businessAreaData: null,
    opStatusData: null,
    ctlNameData: null,
    ctlTwoNameData: null,
    ctlThreeNameData: null,
    yearData: null,
    monthData: null,
    lastOpenRefreshDate: null,
    lastClosedRefreshDate: null,
  };

  const selectGlAccRef = useRef();
  const selectGlTypeRef = useRef();
  const selectBARef = useRef();

  const [showFilters, setShowFilters] = useState(true);
  const [agingData, setAgingData] = useState([]);
  const [agingCountData, setAgingCountData] = useState([]);
  const [vendorData, setVendorData] = useState([]);
  const [topVendorData, setTopVendorData] = useState([]);
  const [agingCTLData, setAgingCTLData] = useState([]);
  const [agingRemarkData, setAgingRemarkData] = useState([]);
  const { showPopup } = usePopupManager();
  const [showDashboard, setShowDashboard] = useState(false);
  const [showDetailedDashboard, setShowDetailedDashboard] = useState(false);
  const [showApplySummary, setShowApplySummary] = useState(true);
  const [showApplyDeatiled, setShowApplyDeatiled] = useState(false);
  const [isLoading, setIsLoading] = useState();
  const [hasApplied, setHasApplied] = useState(false);
  const [filters, setFilters] = useState(initialFilters);
  const [entityOptions, setEntityOptions] = useState([]);
  const [glAccOptions, setGlAccOptions] = useState([]);
  const [glTypeOptions, setGlTypeOptions] = useState([]);
  const [businessAreaOptions, setBusinessAreaOptions] = useState([]);
  const [opStatusOptions, setOpStatusOptions] = useState([]);
  const [ctlNameOptions, setCtlNameOptions] = useState([]);
  const [ctlTwoNameOptions, setCtlNameTwoOptions] = useState([]);
  const [ctlThreeNameOptions, setCtlThreeNameOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);
  const [entity, setEntity] = useState();
  const [glAcc, setGlAcc] = useState();
  const [glType, setGlType] = useState();
  const [businessArea, setBusinessArea] = useState();
  const [opStatus, setOpStatus] = useState();
  const [ctlName, setCtlName] = useState();
  const [ctlTwoName, setCtlTwoName] = useState();
  const [ctlThreeName, setCtlThreeName] = useState();
  const [year, setYear] = useState();
  const [month, setMonth] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1);
  const itemsPerPage = 100;
  const [selectedPage, setSelectedPage] = useState();
  const [data, setData] = useState([]);
  const [dataCSV, setDataCSV] = useState([]);
  const [startPage, setStartPage] = useState(0);
  const [endPage, setEndPage] = useState(100);
  const [dataLoading, setdataLoading] = useState(false);
  const [LastRefreshOpenDate, setLastRefreshOpenDate] = useState("");
  const [LastRefreshCloseDate, setLastRefreshCloseDate] = useState("");
  const [tableData, setTableData] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [defaultColumnData, setDefaultColumnData] = useState([]);

  useEffect(() => {
    fetchData(filters);
  }, []);

  const fetchData = (filters) => {
    console.log("Fetching with", filters);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '20px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '50px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const columns = [
    { header: "Entity", accessor: "entity" },
    { header: "GL", accessor: "gl_account" },
    { header: "GL Description", accessor: "gl_description" },
    { header: "UOM", accessor: "uom" },
    { header: "0-1 Month", accessor: "0_1_month" },
    { header: "1-2 Month", accessor: "1-2_months" },
    { header: "2-3 Month", accessor: "2-3_months" },
    { header: "3-6 Month", accessor: "3-6_months" },
    { header: "6-12 Month", accessor: "6-12_months" },
    { header: "1-3 Years", accessor: "1-3_yrs" },
    { header: ">3 Years", accessor: ">3_yr" },
    { header: "Grand Total", accessor: "grand_total" },
  ];

  const fetchEntityOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-entity`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setEntityOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchGLAccountOptions = async (entitySelectedData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/P2P-gl-account`,
        {
          selectedEntityData: entitySelectedData?.map((m) => m?.value) || [],
        },
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          },
        }
      )
        .then((response) => {
          setGlAccOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchGLCTL1Options = async (entitySelectedData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/P2P-gl-ctl1`,
        {
          selectedEntityData: entitySelectedData?.map((m) => m?.value) || [],
        },
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          },
        }
      )
        .then((response) => {
          setCtlNameOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchGLCTL2Options = async (entitySelectedData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/P2P-gl-ctl2`,
        {
          selectedEntityData: entitySelectedData?.map((m) => m?.value) || [],
        },
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          },
        }
      )
        .then((response) => {
          setCtlNameTwoOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchGLCTL3Options = async (entitySelectedData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/P2P-gl-ctl3`,
        {
          selectedEntityData: entitySelectedData?.map((m) => m?.value) || [],
        },
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          },
        }
      )
        .then((response) => {
          setCtlThreeNameOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  // const fetchGLAccountOptions = async () => {
  //   try {
  //     const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-account`, {
  //       headers: {
  //         // Authorization: `Bearer ${token}`,
  //         Authorization: 'Basic YWRtaW4xOjEyMw==',
  //       },
  //     })
  //       .then((response) => {
  //         setGlAccOptions(response.data);
  //       })
  //   } catch (error) {
  //     console.error('Error fetching entity options:', error);
  //   }
  // };

  // const fetchGLCTL1Options = async () => {
  //   try {
  //     const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-ctl1`, {
  //       headers: {
  //         // Authorization: `Bearer ${token}`,
  //         Authorization: 'Basic YWRtaW4xOjEyMw==',
  //       },
  //     })
  //       .then((response) => {
  //         setCtlNameOptions(response.data);
  //       })
  //   } catch (error) {
  //     console.error('Error fetching entity options:', error);
  //   }
  // };

  // const fetchGLCTL2Options = async () => {
  //   try {
  //     const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-ctl2`, {
  //       headers: {
  //         // Authorization: `Bearer ${token}`,
  //         Authorization: 'Basic YWRtaW4xOjEyMw==',
  //       },
  //     })
  //       .then((response) => {
  //         setCtlNameTwoOptions(response.data);
  //       })
  //   } catch (error) {
  //     console.error('Error fetching entity options:', error);
  //   }
  // };

  // const fetchGLCTL3Options = async () => {
  //   try {
  //     const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-ctl3`, {
  //       headers: {
  //         // Authorization: `Bearer ${token}`,
  //         Authorization: 'Basic YWRtaW4xOjEyMw==',
  //       },
  //     })
  //       .then((response) => {
  //         setCtlThreeNameOptions(response.data);
  //       })
  //   } catch (error) {
  //     console.error('Error fetching entity options:', error);
  //   }
  // };

  const fetchGLOpStatusOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-oprational-status`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setOpStatusOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setYearOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/P2P-gl-month`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setMonthOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  // #4ADE80 = SAP Field, #2563EB =  Manual File Upload,  #FACC15 = System Calculated

  const columnsNames = [
    { header: "Entity", accessor: "entity", fontColor: "#4ADE80" },
    { header: "Vendor Code", accessor: "vendor_code", fontColor: "#4ADE80" },
    { header: "Vendor Name", accessor: "vendor_name", fontColor: "#4ADE80" },
    { header: "Operational Status", accessor: "operational_status", fontColor: "#2563EB" },
    { header: "Sap Document No", accessor: "sap_document_no", fontColor: "#4ADE80" },
    { header: "Fiscal Year", accessor: "fiscal_year", fontColor: "#4ADE80" },
    { header: "Posting Date", accessor: "posting_date", fontColor: "#4ADE80" },
    { header: "Document Type", accessor: "document_type", fontColor: "#4ADE80" },
    { header: "Doc Description", accessor: "Doc_Description", fontColor: "#4ADE80" },
    { header: "Business Area", accessor: "business_area", fontColor: "#4ADE80" },
    { header: "Business Area Description", accessor: "business_area_desc", fontColor: "#4ADE80" },
    { header: "Amount", accessor: "amount", fontColor: "#4ADE80" },
    { header: "Amount in Crs", accessor: "amount_in_crs", fontColor: "#FACC15" },
    { header: "Text", accessor: "text", fontColor: "#4ADE80" },
    { header: "Gl Account", accessor: "gl_account", fontColor: "#4ADE80" },
    { header: "Gl Description", accessor: "gl_description", fontColor: "#4ADE80" },
    { header: "Days", accessor: "days", fontColor: "#FACC15" },
    // { header: "Aging", accessor: "aging", fontColor: "#FACC15"},
    { header: "Aging", accessor: "aging_bucket", fontColor: "#FACC15" },
    { header: "Assignment", accessor: "assignment", fontColor: "#4ADE80" },
    { header: "Purchasing Document", accessor: "purchasing_document", fontColor: "#4ADE80" },
    { header: "Purchase Grp", accessor: "purchase_grp", fontColor: "#4ADE80" },
    { header: "Purchase Grp Description", accessor: "purchase_grp_desc", fontColor: "#4ADE80" },
    { header: "Purchase Org", accessor: "purchase_org", fontColor: "#4ADE80" },
    { header: "Purchase Org Desc", accessor: "purchase_org_desc", fontColor: "#4ADE80" },
    { header: "Commodity Name", accessor: "commodity_name", fontColor: "#4ADE80" },
    { header: "Plant", accessor: "plant", fontColor: "#2563EB" },
    { header: "l3", accessor: "l3", fontColor: "#2563EB" },
    { header: "l2", accessor: "l2", fontColor: "#2563EB" },
    { header: "l1", accessor: "l1", fontColor: "#2563EB" },
    { header: "lc", accessor: "lc", fontColor: "#2563EB" },
    { header: "Reqname", accessor: "reqname", fontColor: "#2563EB" },
    { header: "Provision Amount", accessor: "provision_amount", fontColor: "#2563EB" },
    { header: "Fully Provided", accessor: "fully_provided", fontColor: "#2563EB" },
    { header: "Remarks", accessor: "remarks", fontColor: "#2563EB" },
    { header: "Timeline", accessor: "timeline", fontColor: "#2563EB" },
    { header: "MSME Nonmsme", accessor: "msme_nonmsme", fontColor: "#4ADE80" },
    // { header: "OPEN CLEARED", accessor: "OPEN_CLEARED", fontColor: "#FACC15"  },
    { header: "OPEN CLEARED", accessor: "open_cleared", fontColor: "#FACC15" },
    { header: "Invoice Date", accessor: "invoice_date", fontColor: "#4ADE80" },
    { header: "Net Due Date", accessor: "net_due_date", fontColor: "#4ADE80" },
    { header: "Final Remarks", accessor: "final_remarks", fontColor: "#2563EB" },
    { header: "Plant Non Plant", accessor: "plant_non_plant", fontColor: "#2563EB" },
    { header: "Bg Validity Date", accessor: "bg_validity_date", fontColor: "#FACC15" },
    { header: "Bg Status Remark", accessor: "bg_status_remark", fontColor: "#FACC15" },
    { header: "Vendor Gl Type", accessor: "vendor_gl_type", fontColor: "#FACC15" },
    { header: "Gl Type of Advance", accessor: "gl_type_of_advance", fontColor: "#FACC15" },
    { header: "Document Header Text", accessor: "document_header_text", fontColor: "#4ADE80" },
    { header: "Cost Center", accessor: "cost_center", fontColor: "#4ADE80" },
    { header: "Ap Remark", accessor: "ap_remark", fontColor: "#2563EB" },
    { header: "Current System Date", accessor: "current_system_date", fontColor: "#FACC15" },
    { header: "MSME Category", accessor: "msme_category", fontColor: "#4ADE80" },
    { header: "V Code Block", accessor: "v_code_block", fontColor: "#4ADE80" },
    { header: "V Code Description", accessor: "v_code_description", fontColor: "#FACC15" },
    { header: "Payment Block Code", accessor: "Payment_block_code", fontColor: "#4ADE80" },
    { header: "Payment Block", accessor: "payment_block", fontColor: "#FACC15" },
    { header: "Payt", accessor: "payt", fontColor: "#4ADE80" },
    { header: "Pm", accessor: "pm", fontColor: "#4ADE80" },
    { header: "Pbk", accessor: "pbk", fontColor: "#4ADE80" },
    { header: "Clearing Doc", accessor: "clearing_doc", fontColor: "#4ADE80" },
    { header: "Clearing Date", accessor: "clearing_date", fontColor: "#4ADE80" },
    { header: "PAN No", accessor: "PAN_No", fontColor: "#4ADE80" },
    { header: "Invoice No", accessor: "invoice_no", fontColor: "#4ADE80" }
  ];

  const ColumnForCVEntity = [
    { header: "Entity", accessor: "entity", fontColor: "#2563EB" },
    { header: "Vendor Code", accessor: "vendor_code", fontColor: "#4ADE80" },
    { header: "Vendor Name", accessor: "vendor_name", fontColor: "#4ADE80" },
    { header: "Operational Status", accessor: "operational_status", fontColor: "#2563EB" },
    { header: "Invoice No", accessor: "invoice_no", fontColor: "#4ADE80" },
    { header: "Sap Document No", accessor: "sap_document_no", fontColor: "#4ADE80" },
    { header: "Fiscal Year", accessor: "fiscal_year", fontColor: "#4ADE80" },
    { header: "Posting Date", accessor: "posting_date", fontColor: "#4ADE80" },
    { header: "Document Type", accessor: "document_type", fontColor: "#4ADE80" },
    { header: "Doc Description", accessor: "Doc_Description", fontColor: "#4ADE80" },
    { header: "Business Area", accessor: "business_area", fontColor: "#4ADE80" },
    { header: "Business Area Description", accessor: "business_area_desc", fontColor: "#2563EB" },
    { header: "Amount", accessor: "amount", fontColor: "#4ADE80" },
    { header: "Amount in Crs", accessor: "amount_in_crs", fontColor: "#FACC15" },
    { header: "Text", accessor: "text", fontColor: "#4ADE80" },
    { header: "Gl Account", accessor: "gl_account", fontColor: "#4ADE80" },
    { header: "Gl Description", accessor: "gl_description", fontColor: "#4ADE80" },
    { header: "Days", accessor: "days", fontColor: "#FACC15" },
    // { header: "Aging", accessor: "aging", fontColor: "#FACC15" },
    { header: "Aging", accessor: "aging_bucket", fontColor: "#FACC15" },
    { header: "Assignment", accessor: "assignment", fontColor: "#4ADE80" },
    { header: "Purchasing Document", accessor: "purchasing_document", fontColor: "#4ADE80" },
    { header: "Purchase Grp", accessor: "purchase_grp", fontColor: "#4ADE80" },
    { header: "Purchase Grp Description", accessor: "purchase_grp_desc", fontColor: "#4ADE80" },
    { header: "Purchase Org", accessor: "purchase_org", fontColor: "#4ADE80" },
    { header: "Purchase Org Desc", accessor: "purchase_org_desc", fontColor: "#4ADE80" },
    { header: "Commodity Name", accessor: "commodity_name", fontColor: "#4ADE80" },
    { header: "Plant", accessor: "plant", fontColor: "#2563EB" },
    { header: "L3", accessor: "l3", fontColor: "#2563EB" },
    { header: "L2", accessor: "l2", fontColor: "#2563EB" },
    { header: "L1", accessor: "l1", fontColor: "#2563EB" },
    { header: "LC", accessor: "lc", fontColor: "#2563EB" },
    { header: "Reqname", accessor: "reqname", fontColor: "#2563EB" },
    { header: "Provision Amount", accessor: "provision_amount", fontColor: "#2563EB" },
    { header: "Fully Provided", accessor: "fully_provided", fontColor: "#2563EB" },
    { header: "Remarks", accessor: "remarks", fontColor: "#2563EB" },
    { header: "Timeline", accessor: "timeline", fontColor: "#2563EB" },
    { header: "Invoice Date", accessor: "invoice_date", fontColor: "#4ADE80" },
    { header: "Net Due Date", accessor: "net_due_date", fontColor: "#4ADE80" },
    { header: "Final Remarks", accessor: "final_remarks", fontColor: "#2563EB" },
    { header: "Plant Non Plant", accessor: "plant_non_plant", fontColor: "#2563EB" },
    { header: "Bg Validity Date", accessor: "bg_validity_date", fontColor: "#FACC15" },
    { header: "Bg Status Remark", accessor: "bg_status_remark", fontColor: "#FACC15" },
    { header: "Vendor Gl Type", accessor: "vendor_gl_type", fontColor: "#FACC15" },
    { header: "Gl Type of Advance", accessor: "gl_type_of_advance", fontColor: "#FACC15" },
    { header: "Document Header Text", accessor: "document_header_text", fontColor: "#4ADE80" },
    { header: "Cost Center", accessor: "cost_center", fontColor: "#4ADE80" },
    { header: "Ap Remark", accessor: "ap_remark", fontColor: "#2563EB" },
    { header: "Current System Date", accessor: "current_system_date", fontColor: "#FACC15" },
    { header: "MSME Category", accessor: "msme_category", fontColor: "#4ADE80" },
    { header: "MSME Nonmsme", accessor: "msme_nonmsme", fontColor: "#4ADE80" },
    { header: "V Code Block", accessor: "v_code_block", fontColor: "#4ADE80" },
    { header: "Payt", accessor: "payt", fontColor: "#4ADE80" },
    { header: "Pm", accessor: "pm", fontColor: "#4ADE80" },
    { header: "Pbk", accessor: "pbk", fontColor: "#4ADE80" },
    { header: "Payment Block", accessor: "payment_block", fontColor: "#4ADE80" },
    { header: "Clearing Doc", accessor: "clearing_doc", fontColor: "#4ADE80" },
    { header: "Clearing Date", accessor: "clearing_date", fontColor: "#4ADE80" },
    { header: "PAN No", accessor: "PAN_No", fontColor: "#4ADE80" },
    // { header: "OPEN CLEARED", accessor: "OPEN_CLEARED", fontColor: "#4ADE80" },
    { header: "OPEN CLEARED", accessor: "open_cleared", fontColor: "#FACC15" },
    { header: "ECC Doc No", accessor: "ecc_doc_no", fontColor: "#2563EB" },
    { header: "ECC FY", accessor: "ecc_fy", fontColor: "#2563EB" },
    { header: "ECC Posting Date", accessor: "ecc_posting_date", fontColor: "#2563EB" }
  ];

  const handleEntityChange = (selected) => {
    // ## Single select entity ##
    // setEntity([selected]);
    // setFilters(prev => ({ ...prev, entityData: [selected] }));
    // ## Multi select entity ##
    setEntity(selected);
    setFilters(prev => ({ ...prev, entityData: selected }));
    fetchGLAccountOptions(selected);
    fetchGLCTL1Options(selected);
    fetchGLCTL2Options(selected);
    fetchGLCTL3Options(selected);
  };

  const handleGLAccountChange = (selected) => {
    if (selected === 'undefined' || selected === null) {
      setGlAcc(selected);
      setFilters(prev => ({ ...prev, glAccData: selected }));
      selectGlTypeRef.current.select.clearValue();
    } else {
      setGlAcc(selected);
      setFilters(prev => ({ ...prev, glAccData: selected }));
      try {
        const response = axios.post(`${API_BASE_URL}/api/P2P-gl-type`,
          {
            selectedglacc: selected?.map((m) => m?.value) || [],
          },
          {
            headers: {
              // Authorization: `Bearer ${token}`,
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        )
          .then((response) => {
            setGlTypeOptions(response.data);
          })
      } catch (error) {
        console.error('Error fetching entity options:', error);
      }
    }
  };

  const handleGLTypeChange = (selected) => {
    if (selected === 'undefined' || selected === null) {
      setGlType(selected);
      setFilters(prev => ({ ...prev, glTypeData: selected }));
      selectBARef.current.select.clearValue();
    } else {
      setGlType(selected);
      setFilters(prev => ({ ...prev, glTypeData: selected }));
    }
  };

  const handleBusinessChange = (selected) => {
    setBusinessArea(selected);
    setFilters(prev => ({ ...prev, businessAreaData: selected }));
  };

  const handleOpStatusChange = (selected) => {
    setOpStatus(selected);
    setFilters(prev => ({ ...prev, opStatusData: selected }));
  };

  const handleCTLNameChange = (selected) => {
    setCtlName(selected);
    setFilters(prev => ({ ...prev, ctlNameData: selected }));
  };

  const handleCTLTwoNameChange = (selected) => {
    setCtlTwoName(selected);
    setFilters(prev => ({ ...prev, ctlTwoNameData: selected }));
  };

  const handleCTLThreeNameChange = (selected) => {
    setCtlThreeName(selected);
    setFilters(prev => ({ ...prev, ctlThreeNameData: selected }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters(prev => ({ ...prev, yearData: selected }));
  };

  const handleMonthChange = (selected) => {
    setMonth(selected);
    setFilters(prev => ({ ...prev, monthData: selected }));
  };

  const handleApplyDetailed = () => {
    const entity_data = entity?.map((m) => m?.value) || [];
    if (entity_data.includes("CV")) {
      setDefaultColumnData(ColumnForCVEntity);
    } else {
      setDefaultColumnData(columnsNames);
    }
    const gl_acc_data = glAcc?.map((m) => m?.value) || [];
    const gl_type_data = glType?.map((m) => m?.value) || [];
    const business_area_data = businessArea?.map((m) => m?.value) || [];
    const op_status_data = opStatus?.map((m) => m?.value) || [];
    const ctl1_data = ctlName?.map((m) => m?.value) || [];
    const ctl2_data = ctlTwoName?.map((m) => m?.value) || [];
    const ctl3_data = ctlThreeName?.map((m) => m?.value) || [];
    const year_data = year?.map((m) => m?.value) || [];
    const month_data = month?.map((m) => m?.value) || [];
    const page = selectedPage || 1;
    const limit = itemsPerPage;
    const offset = (page - 1) * limit;

    if (entity_data && entity_data.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    const fetchTreadmarkData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(`${API_BASE_URL}/api/GL-reconcilation-DetailedView`,
          {
            selectedentity: entity_data,
            selectedglacc: gl_acc_data,
            selectedgltype: gl_type_data,
            selectedbusinessarea: business_area_data,
            selectedOpStatus: op_status_data,
            selectedctl1: ctl1_data,
            selectedctl2: ctl2_data,
            selectedctl3: ctl3_data,
            selectedyear: year_data,
            selectedmonth: month_data,
            start: startPage,
            end: endPage,
            limit: limit,
            offset: offset,
          },
          {
            headers: {
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        );

        setTableData(response.data.data);
        setTotalRecords(response.data.total_count);
      } catch (error) {
        console.error('Error fetching trademark data:', error);
      } finally {
        setdataLoading(false);
        setIsLoading(false);
      }
    };

    fetchTreadmarkData();
  }

  const handleApply = () => {
    const entity_data = entity?.map((m) => m?.value) || [];
    if (entity_data.includes("CV")) {
      setDefaultColumnData(ColumnForCVEntity);
    } else {
      setDefaultColumnData(columnsNames);
    }
    const gl_acc_data = glAcc?.map((m) => m?.value) || [];
    const gl_type_data = glType?.map((m) => m?.value) || [];
    const business_area_data = businessArea?.map((m) => m?.value) || [];
    const op_status_data = opStatus?.map((m) => m?.value) || [];
    const ctl1_data = ctlName?.map((m) => m?.value) || [];
    const ctl2_data = ctlTwoName?.map((m) => m?.value) || [];
    const ctl3_data = ctlThreeName?.map((m) => m?.value) || [];
    const year_data = year?.map((m) => m?.value) || [];
    const month_data = month?.map((m) => m?.value) || [];
    const page = selectedPage || 1;
    const limit = itemsPerPage;
    const offset = (page - 1) * limit;

    if (entity_data && entity_data.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    const fetchDataAginingAmt = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(`${API_BASE_URL}/api/GL-reconcilation-AgingWise-amt`,
          {
            selectedentity: entity_data,
            selectedglacc: gl_acc_data,
            selectedgltype: gl_type_data,
            selectedbusinessarea: business_area_data,
            selectedOpStatus: op_status_data,
            selectedctl1: ctl1_data,
            selectedctl2: ctl2_data,
            selectedctl3: ctl3_data,
            selectedyear: year_data,
            selectedmonth: month_data,
            start: startPage,
            end: endPage,
          },
          {
            headers: {
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        );
        setAgingData(response.data);
      } catch (error) {
        console.error('Error fetching trademark data:', error);
      } finally {
        setdataLoading(false);
        setIsLoading(false);
      }
    };

    const fetchDataAginingCount = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(`${API_BASE_URL}/api/GL-reconcilation-AgingWise-count`,
          {
            selectedentity: entity_data,
            selectedglacc: gl_acc_data,
            selectedgltype: gl_type_data,
            selectedbusinessarea: business_area_data,
            selectedOpStatus: op_status_data,
            selectedctl1: ctl1_data,
            selectedctl2: ctl2_data,
            selectedctl3: ctl3_data,
            selectedyear: year_data,
            selectedmonth: month_data,
            start: startPage,
            end: endPage,
          },
          {
            headers: {
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        );
        setAgingCountData(response.data);
      } catch (error) {
        console.error('Error fetching trademark data:', error);
      } finally {
        setdataLoading(false);
        setIsLoading(false);
      }
    };

    const fetchDataVendorWise = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(`${API_BASE_URL}/api/GL-reconcilation-VendorWise-amt`,
          {
            selectedentity: entity_data,
            selectedglacc: gl_acc_data,
            selectedgltype: gl_type_data,
            selectedbusinessarea: business_area_data,
            selectedOpStatus: op_status_data,
            selectedctl1: ctl1_data,
            selectedctl2: ctl2_data,
            selectedctl3: ctl3_data,
            selectedyear: year_data,
            selectedmonth: month_data,
            start: startPage,
            end: endPage,
          },
          {
            headers: {
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        );
        setVendorData(response.data);
      } catch (error) {
        console.error('Error fetching trademark data:', error);
      } finally {
        setdataLoading(false);
        setIsLoading(false);
      }
    };

    const fetchDataTopVendorWise = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(`${API_BASE_URL}/api/GL-reconcilation-TopVendor`,
          {
            selectedentity: entity_data,
            selectedglacc: gl_acc_data,
            selectedgltype: gl_type_data,
            selectedbusinessarea: business_area_data,
            selectedOpStatus: op_status_data,
            selectedctl1: ctl1_data,
            selectedctl2: ctl2_data,
            selectedctl3: ctl3_data,
            selectedyear: year_data,
            selectedmonth: month_data,
            start: startPage,
            end: endPage,
          },
          {
            headers: {
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        );
        setTopVendorData(response.data);
      } catch (error) {
        console.error('Error fetching trademark data:', error);
      } finally {
        setdataLoading(false);
        setIsLoading(false);
      }
    };

    const fetchDataCTLWise = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(`${API_BASE_URL}/api/GL-reconcilation-CTLWise`,
          {
            selectedentity: entity_data,
            selectedglacc: gl_acc_data,
            selectedgltype: gl_type_data,
            selectedbusinessarea: business_area_data,
            selectedOpStatus: op_status_data,
            selectedctl1: ctl1_data,
            selectedctl2: ctl2_data,
            selectedctl3: ctl3_data,
            selectedyear: year_data,
            selectedmonth: month_data,
            start: startPage,
            end: endPage,
          },
          {
            headers: {
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        );
        setAgingCTLData(response.data);
      } catch (error) {
        console.error('Error fetching trademark data:', error);
      } finally {
        setdataLoading(false);
        setIsLoading(false);
      }
    };

    const fetchDataRemarkWise = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(`${API_BASE_URL}/api/GL-reconcilation-RemarkWise`,
          {
            selectedentity: entity_data,
            selectedglacc: gl_acc_data,
            selectedgltype: gl_type_data,
            selectedbusinessarea: business_area_data,
            selectedOpStatus: op_status_data,
            selectedctl1: ctl1_data,
            selectedctl2: ctl2_data,
            selectedctl3: ctl3_data,
            selectedyear: year_data,
            selectedmonth: month_data,
            start: startPage,
            end: endPage,
          },
          {
            headers: {
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        );
        setAgingRemarkData(response.data);
      } catch (error) {
        console.error('Error fetching trademark data:', error);
      } finally {
        setdataLoading(false);
        setIsLoading(false);
      }
    };

    fetchDataAginingAmt();
    fetchDataAginingCount();
    fetchDataVendorWise();
    fetchDataTopVendorWise();
    fetchDataCTLWise();
    fetchDataRemarkWise();
    setShowDashboard(true);
  };

  const handleCSVDownload = () => {
    const csvHeader = columns.map(col => col.header).join(',');
    const csvRows = dataCSV.map(row =>
      columns
        .map(col =>
          `"${String(row[col.accessor] ?? '').replace(/"/g, '""')}"`
        )
        .join(',')
    );
    const csvContent = [csvHeader, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Vendor_GL_Ageing_Report.csv';
    link.click();
  };

  const handleReset = () => {
    setShowDashboard(false);
    setShowDetailedDashboard(false);
    setHasApplied(false);
    setEntity([]);
    setOpStatus([]);
    setGlAcc([]);
    setGlType([]);
    setBusinessArea([]);
    setCtlName([]);
    setCtlTwoName([]);
    setCtlThreeName([]);
    setYear([]);
    setMonth([]);
    setSelectedPage(1);
    setStartPage(0);
    setEndPage(100);
    setData([]);
    setDataCSV([]);
    setTotalRecords(0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    if (dateString.includes('T')) {
      return moment(dateString).format('DD/MM/YYYY');
    }
    return moment(dateString, 'MM/DD/YYYY').format('DD/MM/YYYY');
  };

  const fetchLastRefreshDate = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/GL-reconcilation-last-refresh`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setLastRefreshOpenDate(formatDate(response.data.open_values));
          setLastRefreshCloseDate(formatDate(response.data.closed_values));
          setFilters(prev => ({ ...prev, lastOpenRefreshDate: response.data.open_values }));
          setFilters(prev => ({ ...prev, lastClosedRefreshDate: response.data.closed_values }));
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  useEffect(() => {
    fetchLastRefreshDate();
    fetchEntityOptions();
    fetchGLOpStatusOptions();
    // fetchGLAccountOptions();
    // fetchGLCTL1Options();
    // fetchGLCTL2Options();
    // fetchGLCTL3Options();
    fetchYearOptions();
    fetchMonthOptions();
  }, []);


  const handlePageChange = (page) => {
    setSelectedPage(page);
    setCurrentPage(page);
    handleApplyDetailed();
  };

  // useEffect(() => {
  //   if (hasApplied) {
  //     handleApply();
  //   }
  // }, [hasApplied]);

  useEffect(() => {
    if (glTypeOptions && glTypeOptions.length > 0) {
      setGlType(glTypeOptions);
      try {
        const response = axios.post(`${API_BASE_URL}/api/P2P-gl-business-area`,
          {
            selectedgltype: glTypeOptions?.map((m) => m?.value) || [],
          }, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          },
        }
        )
          .then((response) => {
            setBusinessAreaOptions(response.data);
          })
      } catch (error) {
        console.error('Error fetching entity options:', error);
      }
    } else {
      setGlType([]);
    }
  }, [glTypeOptions]);


  useEffect(() => {
    if (businessAreaOptions && businessAreaOptions.length > 0) {
      setBusinessArea(businessAreaOptions);
    } else {
      setBusinessArea([]);
    }
  }, [businessAreaOptions])


  useEffect(() => {
    if (entityOptions.length && opStatusOptions.length && yearOptions.length && monthOptions.length) {
      let shouldApply = false;

      if (filters.entityData) {
        const ent = entityOptions.some((opt) => opt.value === filters.entityData?.map((m) => m?.value) || []);
        if (ent) {
          setEntity(filters.entityData);
          shouldApply = true;
        }
      }
      if (filters.glAccData) {
        const glacc = glAccOptions.some((opt) => opt.value === filters.glAccData?.map((m) => m?.value) || []);
        if (glacc) {
          setGlAcc(filters.glAccData);
          shouldApply = true;
        }
      }

      if (filters.glTypeData) {
        const gltype = glTypeOptions.some((opt) => opt.value === filters.glTypeData?.map((m) => m?.value) || []);
        if (gltype) {
          setGlType(filters.glTypeData);
          shouldApply = true;
        }
      }

      if (filters.businessAreaData) {
        const BA = businessAreaOptions.some((opt) => opt.value === filters.businessAreaData?.map((m) => m?.value) || []);
        if (BA) {
          setBusinessArea(filters.businessAreaData);
          shouldApply = true;
        }
      }

      if (filters.opStatusData) {
        const BA = opStatusOptions.some((opt) => opt.value === filters.opStatusData?.map((m) => m?.value) || []);
        if (BA) {
          setOpStatus(filters.opStatusData);
          shouldApply = true;
        }
      }

      if (filters.ctlNameData) {
        const ctl1 = ctlNameOptions.some((opt) => opt.value === filters.ctlNameData?.map((m) => m?.value) || []);
        if (ctl1) {
          setCtlName(filters.ctlNameData);
          shouldApply = true;
        }
      }

      if (filters.ctlTwoNameData) {
        const ctl2 = ctlTwoNameOptions.some((opt) => opt.value === filters.ctlTwoNameData?.map((m) => m?.value) || []);
        if (ctl2) {
          setCtlTwoName(filters.ctlTwoNameData);
          shouldApply = true;
        }
      }

      if (filters.ctlThreeNameData) {
        const ctl3 = ctlThreeNameOptions.some((opt) => opt.value === filters.ctlThreeNameData?.map((m) => m?.value) || []);
        if (ctl3) {
          setCtlThreeName(filters.ctlThreeNameData);
        }
      }

      if (filters.yearData) {
        const yr = yearOptions.some((opt) => opt.value === filters.yearData?.map((m) => m?.value) || []);
        if (yr) {
          setYear(filters.yearData);
          shouldApply = true;
        }
      }

      if (filters.monthData) {
        const mth = monthOptions.some((opt) => opt.value === filters.monthData?.map((m) => m?.value) || []);
        if (mth) {
          setMonth(filters.monthData);
          shouldApply = true;
        }
      }

      if (shouldApply) {
        console.log(shouldApply)
        setHasApplied(true);
      }
    }
  }, [entityOptions, ctlNameOptions, ctlTwoNameOptions, ctlThreeNameOptions, yearOptions, monthOptions]);

  // useEffect(() => {
  //   if (hasApplied) {
  //     handleApply();
  //     setHasApplied(false);
  //   }
  // }, [hasApplied]);

  const agingColumns = [
    { header: 'Entity', key: 'Entity', width: '4%' },
    { header: 'G/L Account', key: 'GL_acc', width: '7%' },
    { header: 'GL Description', key: 'GL_Description', width: '10%' },
    { header: '0-1 Month amt', key: '0_30', width: '10%', sortable: true },
    { header: '1-2 Months amt', key: '30_60', width: '10%', sortable: true },
    { header: '2-3 Months amt', key: '60_90', width: '10%', sortable: true },
    { header: '3-6 Months amt', key: '90_180', width: '10%', sortable: true },
    { header: '6-12 Months amt', key: '181_365', width: '10%', sortable: true },
    { header: '1-3 Yrs amt', key: '1_3_year', width: '10%', sortable: true },
    { header: '>3 Yrs amt', key: '3_6_year', width: '10%', sortable: true },
    { header: 'Grand Total amt', key: 'grand_total_amt', width: '10%', sortable: true }
  ];

  const agingCountColumns = [
    { header: 'Entity', key: 'Entity', width: '4%' },
    { header: 'G/L Account', key: 'GL_acc', width: '7%' },
    { header: 'GL Description', key: 'GL_Description', width: '10%' },
    { header: '0-1 Month count', key: '0_30_count', width: '10%', sortable: true },
    { header: '1-2 Months count', key: '30_60_count', width: '10%', sortable: true },
    { header: '2-3 Months count', key: '60_90_count', width: '10%', sortable: true },
    { header: '3-6 Months count', key: '90_180_count', width: '10%', sortable: true },
    { header: '6-12 Months count', key: '181_365_count', width: '10%', sortable: true },
    { header: '1-3 Yrs count', key: '1_3_year_count', width: '10%', sortable: true },
    { header: '>3 Yrs count', key: '3_6_year_count', width: '10%', sortable: true },
    { header: 'Grand Total count', key: 'grand_total_count', width: '10%', sortable: true }
  ];

  const vendorColumns = [
    { header: 'Vendor Code', key: 'vendor_code', width: '7.70%' },
    { header: 'Vendor Name', key: 'vendor_name', width: '7.70%' },
    { header: 'G/L Account', key: 'GL_acc', width: '7.70%' },
    { header: 'GL Description', key: 'GL_Description', width: '7.70%' },
    { header: 'Oprational Status', key: 'op_status', width: '7.70%' },
    { header: '0-1 Month amt', key: '0_30', width: '7.70%', sortable: true },
    { header: '1-2 Month amt', key: '30_60', width: '7.70%', sortable: true },
    { header: '2-3 Month amt', key: '60_90', width: '7.70%', sortable: true },
    { header: '3-6 Month amt', key: '90_180', width: '7.70%', sortable: true },
    { header: '6-12 Month amt', key: '181_365', width: '7.70%', sortable: true },
    { header: '1-3 Years amt', key: '1_3_year', width: '7.70%', sortable: true },
    { header: '>3 Years amt', key: '3_6_year', width: '7.70%', sortable: true },
    { header: 'Grand Total amt', key: 'grand_total_amt', width: '7.70%', sortable: true }
  ];

  const topVendorColumns = [
    { header: 'Account', key: 'account', width: '16.66%' },
    { header: 'Name', key: 'name', width: '16.66%' },
    { header: 'G/L Account', key: 'GL_acc', width: '16.66%' },
    { header: 'GL Description', key: 'GL_Description', width: '16.66%' },
    { header: 'Oprational Status', key: 'op_status', width: '16.66%' },
    { header: 'Amount in Crs', key: 'amount', width: '16.66%', sortable: true },
  ];

  const agingCTLColumns = [
    { header: 'Entity', key: 'Entity', width: '3%' },
    { header: 'L1', key: 'CTL1', width: '5%' },
    { header: 'L2', key: 'CTL2', width: '5%' },
    { header: 'L3', key: 'CTL3', width: '5%' },
    { header: '0-1 Month amt', key: '0_30', width: '10%', sortable: true },
    { header: '1-2 Month amt', key: '30_60', width: '10%', sortable: true },
    { header: '2-3 Month amt', key: '60_90', width: '10%', sortable: true },
    { header: '3-6 Month amt', key: '90_180', width: '10%', sortable: true },
    { header: '6-12 Month amt', key: '181_365', width: '10%', sortable: true },
    { header: '1-3 Years amt', key: '1_3_year', width: '10%', sortable: true },
    { header: '>3 Years amt', key: '3_6_year', width: '10%', sortable: true },
    { header: 'Grand Total amt', key: 'grand_total_amt', width: '10%', sortable: true }
  ];

  const agingRemarkColumns = [
    { header: 'Entity', key: 'Entity', width: '4%' },
    { header: 'Timeline Remarks', key: 'Timeline_Remarks', width: '8%' },
    { header: 'Final Remarks', key: 'final_remarks', width: '8%' },
    { header: '0-1 Month amt', key: '0_30', width: '10%', sortable: true },
    { header: '1-2 Month amt', key: '30_60', width: '10%', sortable: true },
    { header: '2-3 Month amt', key: '60_90', width: '10%', sortable: true },
    { header: '3-6 Month amt', key: '90_180', width: '10%', sortable: true },
    { header: '6-12 Month amt', key: '181_365', width: '10%', sortable: true },
    { header: '1-3 Years amt', key: '1_3_year', width: '10%', sortable: true },
    { header: '>3 Years amt', key: '3_6_year', width: '10%', sortable: true },
    { header: 'Grand Total amt', key: 'grand_total_amt', width: '10%', sortable: true }
  ];

  const handleDetailClick = () => {
    setShowDashboard(false);
    setShowApplyDeatiled(true);
    setShowApplySummary(false);
    setShowDetailedDashboard(true);
    handleApplyDetailed();
  }

  const handleBackClick = () => {
    // setShowDashboard(true);
    setShowApplyDeatiled(false);
    setShowApplySummary(true);
    setShowDetailedDashboard(false);
    handleApply();
  }

  const colorsForTables = [
    "#4ADE80",
    "#FACC15",
    "#DC2626",
    "#2c3e50",
    "#2563EB"
  ]

  // ##### Old columns for PV/EV before CV go-live #####
  // const columnsNames = [
  //   { header: "Entity", accessor: "entity", fontColor: "#4ADE80" },
  //   { header: "Vendor Code", accessor: "vendor_code", fontColor: "#4ADE80" },
  //   { header: "Vendor Name", accessor: "vendor_name", fontColor: "#4ADE80" },
  //   { header: "Operational Status", accessor: "operational_status", fontColor: "#2563EB" },
  //   { header: "Sap Document No", accessor: "sap_document_no", fontColor: "#4ADE80" },
  //   { header: "Fiscal Year", accessor: "fiscal_year", fontColor: "#4ADE80" },
  //   { header: "Posting Date", accessor: "posting_date", fontColor: "#4ADE80" },
  //   { header: "Document Type", accessor: "document_type", fontColor: "#4ADE80" },
  //   { header: "Doc Description", accessor: "Doc_Description", fontColor: "#4ADE80" },
  //   { header: "Business Area", accessor: "business_area", fontColor: "#4ADE80" },
  //   { header: "Business Area Description", accessor: "business_area_desc", fontColor: "#4ADE80"  },
  //   { header: "Amount", accessor: "amount", fontColor: "#4ADE80" },
  //   { header: "Amount in Crs", accessor: "amount_in_crs", fontColor: "#FACC15" },
  //   { header: "Text", accessor: "text", fontColor: "#4ADE80" },
  //   { header: "Gl Account", accessor: "gl_account", fontColor: "#4ADE80" },
  //   { header: "Gl Description", accessor: "gl_description", fontColor: "#4ADE80" },
  //   { header: "Days", accessor: "days", fontColor: "#FACC15"  },
  //   { header: "Aging", accessor: "aging", fontColor: "#FACC15"  },
  //   { header: "Assignment", accessor: "assignment", fontColor: "#4ADE80" },
  //   { header: "Purchasing Document", accessor: "purchasing_document", fontColor: "#4ADE80" },
  //   { header: "Purchase Grp", accessor: "purchase_grp", fontColor: "#4ADE80" },
  //   { header: "Purchase Grp Description", accessor: "purchase_grp_desc", fontColor: "#4ADE80" },
  //   { header: "Purchase Org", accessor: "purchase_org", fontColor: "#4ADE80" },
  //   { header: "Purchase Org Desc", accessor: "purchase_org_desc", fontColor: "#4ADE80" },
  //   { header: "Commodity Name", accessor: "commodity_name", fontColor: "#4ADE80" },
  //   { header: "Plant", accessor: "plant", fontColor: "#2563EB"  },
  //   { header: "l3", accessor: "l3", fontColor: "#2563EB"  },
  //   { header: "l2", accessor: "l2", fontColor: "#2563EB"  },
  //   { header: "l1", accessor: "l1", fontColor: "#2563EB"  },
  //   { header: "lc", accessor: "lc", fontColor: "#2563EB"  },
  //   { header: "Reqname", accessor: "reqname", fontColor: "#2563EB"  },
  //   { header: "Provision Amount", accessor: "provision_amount", fontColor: "#2563EB"  },
  //   { header: "Fully Provided", accessor: "fully_provided", fontColor: "#2563EB"  },
  //   { header: "Remarks", accessor: "remarks", fontColor: "#2563EB"  },
  //   { header: "Timeline", accessor: "timeline", fontColor: "#2563EB"  },
  //   { header: "MSME Nonmsme", accessor: "msme_nonmsme", fontColor: "#4ADE80" },
  //   { header: "OPEN CLEARED", accessor: "OPEN_CLEARED", fontColor: "#FACC15"  },
  //   { header: "Invoice Date", accessor: "invoice_date", fontColor: "#4ADE80" },
  //   { header: "Net Due Date", accessor: "net_due_date", fontColor: "#4ADE80" },
  //   { header: "Final Remarks", accessor: "final_remarks", fontColor: "#2563EB"  },
  //   { header: "Plant Non Plant", accessor: "plant_non_plant", fontColor: "#2563EB"  },
  //   // { header: "Bg Validity Date", accessor: "bg_validity_date", fontColor: "#4ADE80" },
  //   // { header: "Bg Status Remark", accessor: "bg_status_remark", fontColor: "#4ADE80" },
  //   { header: "Bg Validity Date", accessor: "bg_validity_date", fontColor: "#FACC15" },
  //   { header: "Bg Status Remark", accessor: "bg_status_remark", fontColor: "#FACC15" },
  //   // { header: "Vendor Gl Type", accessor: "vendor_gl_type", fontColor: "#2563EB"  },
  //   { header: "Vendor Gl Type", accessor: "vendor_gl_type", fontColor: "#FACC15"  },
  //   // { header: "Gl Type of Advance", accessor: "gl_type_of_advance", fontColor: "#2563EB"  },
  //   { header: "Gl Type of Advance", accessor: "gl_type_of_advance", fontColor: "#FACC15"  },
  //   { header: "Document Header Text", accessor: "document_header_text", fontColor: "#4ADE80" },
  //   { header: "Cost Center", accessor: "cost_center", fontColor: "#4ADE80" },
  //   { header: "Ap Remark", accessor: "ap_remark", fontColor: "#2563EB"  },
  //   { header: "Current System Date", accessor: "current_system_date", fontColor: "#FACC15"  },
  //   { header: "MSME Category", accessor: "msme_category", fontColor: "#4ADE80" },
  //   { header: "V Code Block", accessor: "v_code_block", fontColor: "#4ADE80" },
  //   { header: "V Code Description", accessor: "v_code_description", fontColor: "#FACC15" },
  //   { header: "Payment Block Code", accessor: "Payment_block_code", fontColor: "#4ADE80" },
  //   { header: "Payment Block", accessor: "payment_block", fontColor: "#FACC15" },
  //   { header: "Payt", accessor: "payt", fontColor: "#4ADE80" },
  //   { header: "Pm", accessor: "pm", fontColor: "#4ADE80" },
  //   { header: "Pbk", accessor: "pbk", fontColor: "#4ADE80" },
  //   { header: "Clearing Doc", accessor: "clearing_doc", fontColor: "#4ADE80" },
  //   { header: "Clearing Date", accessor: "clearing_date", fontColor: "#4ADE80" },
  //   { header: "PAN No", accessor: "PAN_No", fontColor: "#4ADE80" },
  //   { header: "Invoice No", accessor: "invoice_no", fontColor: "#4ADE80" }
  // ];

  const downloadCSV = async () => {
    try {
      const selected_col_data = selectedColumns || [];
      const entity_data = entity?.map((m) => m?.value) || [];
      const gl_acc_data = glAcc?.map((m) => m?.value) || [];
      const gl_type_data = glType?.map((m) => m?.value) || [];
      const business_area_data = businessArea?.map((m) => m?.value) || [];
      const op_status_data = opStatus?.map((m) => m?.value) || [];
      const ctl1_data = ctlName?.map((m) => m?.value) || [];
      const ctl2_data = ctlTwoName?.map((m) => m?.value) || [];
      const ctl3_data = ctlThreeName?.map((m) => m?.value) || [];
      const year_data = year?.map((m) => m?.value) || [];
      const month_data = month?.map((m) => m?.value) || [];
      const page = selectedPage || 1;
      const limit = itemsPerPage;
      const offset = (page - 1) * limit;
      const bodyData = {
        selectedColData: selected_col_data,
        selectedentity: entity_data,
        selectedglacc: gl_acc_data,
        selectedgltype: gl_type_data,
        selectedbusinessarea: business_area_data,
        selectedOpStatus: op_status_data,
        selectedctl1: ctl1_data,
        selectedctl2: ctl2_data,
        selectedctl3: ctl3_data,
        selectedyear: year_data,
        selectedmonth: month_data,
        start: startPage,
        end: endPage,
        limit: limit,
        offset: offset,
      };

      setIsLoading(true);

      const response = await fetch(`${API_BASE_URL}/api/GL-reconcilation-DetailedView-Download`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        showPopup({
          type: MESSAGE_TYPE.FAILURE,
          contextText: MESSAGE_TYPE.FAILURE,
          info: "Failed to download CSV.",
        });
        throw new Error("Failed to download CSV");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      if (entity_data.includes("CV")) {
        link.setAttribute("download", "CV_vendor_GL_Details_report.csv");
      } else if (entity_data.includes("PV")) {
        link.setAttribute("download", "PV_vendor_GL_Details_report.csv");
      } else {
        link.setAttribute("download", "EV_vendor_GL_Details_report.csv");
      }
      // link.setAttribute("download", "vendor_GL_Details_report.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setIsLoading(false);
    } catch (error) {
      console.error("Download error:", error);
      setIsLoading(false);
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: "Failed to download CSV.",
      });
    }
  };

  return (
    <>
      <div className={styles.domain_tile}>
        <div className={styles.domain_tile_header}>Advance GL Ageing Summary Report</div>
        <div className={styles.domain_tile_header_last}>Last Refresh Date:{LastRefreshOpenDate}</div>
        <button
          className={styles.detail_view_btn}
          onClick={() => setShowFilters(prev => !prev)}
        >
          {showFilters ? <FiChevronsUp size={12} /> : <FiChevronsDown size={10} />}
        </button>
        {showDashboard && (
          <button
            className={styles.detail_view_btn}
            onClick={handleDetailClick}
          >
            Detailed View <span className={styles.arrow}>»</span>
          </button>
        )}
        {showDetailedDashboard && (
          <button
            className={styles.detail_view_btn}
            onClick={handleBackClick}
          >
            Back <span className={styles.arrow}>»</span>
          </button>
        )}
      </div>
      {showFilters && (
        <div className={styles.filter_panel_container}>
          <div className={styles.filter_panel_row}>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Entity
                <span style={{ color: "red" }}>*</span></label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  value={entity}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  onChange={handleEntityChange}
                  options={entityOptions}
                  isSearchable={true}
                  styles={customStyles}
                />
              </div>
            </div>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>GL Account</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  ref={selectGlAccRef}
                  value={glAcc}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  onChange={handleGLAccountChange}
                  options={glAccOptions}
                  isSearchable={true}
                  styles={customStyles}
                />
              </div>
            </div>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>GL Type</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  ref={selectGlTypeRef}
                  value={glType}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  onChange={handleGLTypeChange}
                  options={glTypeOptions}
                  isSearchable={true}
                  styles={customStyles}
                />
              </div>
            </div>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Business Area</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  ref={selectBARef}
                  value={businessArea}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  onChange={handleBusinessChange}
                  options={businessAreaOptions}
                  isSearchable={true}
                  styles={customStyles}
                />
              </div>
            </div>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Operational Status</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  value={opStatus}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  onChange={handleOpStatusChange}
                  options={opStatusOptions}
                  isSearchable={true}
                  styles={customStyles}
                />
              </div>
            </div>
          </div>
          <div className={`${styles.filter_panel_row} mt-2`}>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>L1 Name</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  value={ctlName}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  onChange={handleCTLNameChange}
                  options={ctlNameOptions}
                  isSearchable={true}
                  styles={customStyles}
                />
              </div>
            </div>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>L2 Name</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  value={ctlTwoName}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  onChange={handleCTLTwoNameChange}
                  options={ctlTwoNameOptions}
                  isSearchable={true}
                  styles={customStyles}
                />
              </div>
            </div>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>L3 Name</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  value={ctlThreeName}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  onChange={handleCTLThreeNameChange}
                  options={ctlThreeNameOptions}
                  isSearchable={true}
                  styles={customStyles}
                />
              </div>
            </div>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Fiscal Year</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  value={year}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  onChange={handleYearChange}
                  options={yearOptions}
                  isSearchable={true}
                  styles={customStyles}
                />
              </div>
            </div>
            <div className={styles.filter_panel_col}>
              <label className={styles.filter_label}>Month</label>
              <div className={styles.filter_select_wrapper}>
                <Select
                  value={month}
                  isMulti={true}
                  onChange={handleMonthChange}
                  closeMenuOnSelect={false}
                  options={monthOptions}
                  isSearchable={true}
                  styles={customStyles}
                />
              </div>
            </div>
            {showApplySummary && (
              <div className={styles.filter_panel_col}>
                <div className="filter-panel-col action-buttons">
                  <button onClick={handleApply} className="btn apply-btn">
                    Apply
                  </button>
                  <button onClick={handleReset} className="btn reset-btn">
                    Reset
                  </button>
                </div>
              </div>
            )}
            {showApplyDeatiled && (
              <div className={styles.filter_panel_col}>
                <div className="filter-panel-col action-buttons">
                  <button onClick={handleApplyDetailed} className="btn apply-btn">
                    Apply
                  </button>
                  <button onClick={handleReset} className="btn reset-btn">
                    Reset
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
          </div>
        </div>
      )}

      {showDashboard && (
        <div>
          <div className="row mb-2">
            <div className="col-md-4">
              <GLAgingDoughnutChartTable
                title="GL Wise Ageing (&#8377; in Crs)"
                columns={agingColumns}
                data={agingData}
                totalAmount="38.58"
                DataTitle="This metric is SAP based."
              />
            </div>
            <div className="col-md-4">
              <GLAgingDoughnutChartTable
                title="GL Wise Ageing Count"
                columns={agingCountColumns}
                data={agingCountData}
                totalAmount="38.58"
                DataTitle="This metric is SAP based."
              />
            </div>
            <div className="col-md-4">
              <ReusableTableMini
                title="Vendor wise Aging (&#8377; in Crs)"
                columns={vendorColumns}
                data={vendorData}
                totalAmount="38.58"
                DataTitle="This metric is SAP based."
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-4">
              <ReusableChartTableMini
                title="Top 10 Vendors"
                columns={topVendorColumns}
                data={topVendorData}
                totalAmount="38.58"
                DataTitle="This metric is SAP based."
              />
            </div>
            <div className="col-md-4">
              <ReusableTableMini
                title="CTL Wise Ageing (&#8377; in Crs)"
                columns={agingCTLColumns}
                data={agingCTLData}
                totalAmount="38.58"
                DataTitle="This metric is SAP + Manual data based."
              />
            </div>
            <div className="col-md-4">
              <ReusableTableMini
                title="Remarkwise Ageing (&#8377; in Crs)"
                columns={agingRemarkColumns}
                data={agingRemarkData}
                totalAmount="38.58"
                DataTitle="This metric is SAP + Manual data based."
              />
            </div>
          </div>
        </div>
      )}
      {showDetailedDashboard && (
        // <GLReusableTable
        // data={tableData} columns={columnsNames} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={totalRecords} handleCSVDownload={downloadCSV} dataLoading={dataLoading} onSelectedColumnsChange={setSelectedColumns}
        // />
        <GLReusableTable
          data={tableData} columns={defaultColumnData} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={totalRecords} handleCSVDownload={downloadCSV} dataLoading={dataLoading} onSelectedColumnsChange={setSelectedColumns}
        />
      )}
    </>
  );
};

export default GLRconcilationDashboard;